import React from 'react';

import { Spinner } from '@zillow/constellation';

import { StyledSpinnerContainer } from './StyledComponents';

const SpinnerContainer = ({ size = 'sm', height = '200px' }) => (
    <StyledSpinnerContainer height={height}>
        <Spinner size={size} />
    </StyledSpinnerContainer>
);

export default SpinnerContainer;
